import { useEffect, useState } from 'react';
import { Box, Flex, Spinner } from '@chakra-ui/react';

import { StructureNode } from '@app/api/models/structure';
import { useApi } from '@app/hooks';
import { Txt } from '@app/components/common';
import { useQueryTable } from '@app/components/common/table/query-table';

export const ParentColumn = ({ bossId }: { bossId: number | null }) => {
  const api = useApi();
  const { data } = useQueryTable();
  const [parent, setParent] = useState<StructureNode | null>(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (bossId === null) {
      setParent(null);
      return;
    }
    const parent = (data as StructureNode[]).find(({ id }) => id === bossId);
    if (!parent) {

      (async () => {
        setLoading(true);
        const { data } = await api.structure.getNodes({
          filter: { 
            id: bossId.toString(),
          },
          sort: '+id',
          limit: 1,
          offset: 0,
        });
        setParent(data.data[0]);
        setLoading(false);
      })();
      return;
    }
    setParent(parent);
  }, [bossId]);

  if (bossId === null) {
    return <></>;
  }

  if (loading) {
    return <>
      <Spinner />
    </>;
  }

  return <Flex flexDirection='column'>
    <Flex gap={2} alignItems='center'>
      <Txt color='gray.500'>[{parent?.id}]</Txt>
      <Txt color='brand.500'>{parent?.level?.name}</Txt>
    </Flex>
    <Txt>{parent?.territory}</Txt>
    <Txt color='gray.500'>{parent?.employee?.name}</Txt>
  </Flex>;
};